export default "__VITE_ASSET__of43rT_v__"